export function gerarIcsCompromisso(comp, participantesEmails = []) {
  const escapeIcs = (text) => {
    if (!text) return "";
    return String(text)
      .replace(/\\/g, "\\\\")
      .replace(/;/g, "\\;")
      .replace(/,/g, "\\,")
      .replace(/\n/g, "\\n");
  };

  const fmtData = (dataStr, horaStr) => {
    const [ano, mes, dia] = dataStr.split("-");
    const [h, m] = (horaStr || "00:00").split(":");
    return `${ano}${mes}${dia}T${h}${m}00`;
  };

  const dtStart = fmtData(comp.data_compromisso, comp.hora_inicio);
  const dtEnd = fmtData(comp.data_compromisso, comp.hora_fim || comp.hora_inicio || "23:59");
  const uid = `${comp.id}@onboxapp.com.br`;
  const now = new Date().toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";

  // Montar descrição com quebras reais (não escaped)
  const descricaoLinhas = [
    escapeIcs(comp.descricao || ""),
    comp.link_reuniao ? `Link da reunião: ${escapeIcs(comp.link_reuniao)}` : "",
  ].filter(Boolean).join("\n");

  const attendees = participantesEmails
    .map(email => `ATTENDEE;CN=${escapeIcs(email)};RSVP=TRUE:mailto:${email}`)
    .join("\r\n");

  const icsContent = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//OnBox//Compromissos//PT",
    "METHOD:REQUEST",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${now}`,
    `DTSTART:${dtStart}`,
    `DTEND:${dtEnd}`,
    `SUMMARY:${escapeIcs(comp.titulo)}`,
    `DESCRIPTION:${descricaoLinhas}`,
    comp.local ? `LOCATION:${escapeIcs(comp.local)}` : "",
    comp.link_reuniao ? `URL:${comp.link_reuniao}` : "",
    attendees,
    "STATUS:CONFIRMED",
    "SEQUENCE:0",
    "BEGIN:VALARM",
    "TRIGGER:-PT15M",
    "ACTION:DISPLAY",
    "DESCRIPTION:Lembrete",
    "END:VALARM",
    "END:VEVENT",
    "END:VCALENDAR",
  ].filter(Boolean).join("\r\n");

  return icsContent;
}